import { CustomSelect, SelectOption } from '@consigli/facade';
import { Language } from '@consigli/types';
import { FC } from 'react';
import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface SelectLanguageProps {
  label?: string;
  isDisabled?: boolean;
}

export const SelectLanguage: FC<SelectLanguageProps> = ({ label, isDisabled = false }) => {
  const { t } = useTranslation();

  const { control } = useFormContext<FieldValues>();
  const { field: languageField, fieldState: languageFieldState } = useController({
    name: 'language',
    control,
    rules: {
      validate: (value) => !!value || `${t('createproject.invalid-project-language-empty')}*`,
    },
  });
  const languageOptions: SelectOption[] = [
    {
      label: t('language.en'),
      value: Language.EN,
    },
    {
      label: t('language.fr'),
      value: Language.FR,
    },
    {
      label: t('language.de'),
      value: Language.DE,
    },
    {
      label: t('language.ja'),
      value: Language.JA,
    },
    {
      label: t('language.nb'),
      value: Language.NB,
    },
    {
      label: t('language.nn'),
      value: Language.NN,
    },
    {
      label: t('language.es'),
      value: Language.ES,
    },
    {
      label: t('language.ca'),
      value: Language.CA,
    },
    {
      label: t('language.sv'),
      value: Language.SV,
    },
    {
      label: t('language.vi'),
      value: Language.VI,
    },
    {
      label: t('language.zh'),
      value: Language.ZH,
    },
  ];
  return (
    <div>
      {label && (
        <p className="mt-2 mb-2 text-base font-semibold text-day-neutral-subtle">{label}</p>
      )}
      <CustomSelect
        onChange={(selectedOptions: SelectOption[]) => {
          languageField.onChange(selectedOptions.length > 0 ? selectedOptions[0].value : null);
        }}
        options={languageOptions}
        placeholder={t('language.select')}
        value={
          languageField.value
            ? languageOptions.filter((option) => option.value === languageField.value)
            : []
        }
        noOptionsMessage={t('custom-select.no-options')}
        isDisabled={isDisabled}
      />
      {languageFieldState.invalid && (
        <div className="text-red-700 text-sm">{languageFieldState.error?.message as string}</div>
      )}
    </div>
  );
};
